module.exports = __webpack_public_path__ + "static/media/dots.3aa6da80.svg";